import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    filterSelect: {
      height: 40,
      width: 180,
      display: 'inline-block',
      borderRadius: CornerRadius.r8,
      zIndex: 99,
    },
  },
  {
    name: 'fonts-filter',
  },
);

export default useStyles;
